(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './UpperCornerBadge', './BottomCornerBadge'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./UpperCornerBadge'), require('./BottomCornerBadge'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.UpperCornerBadge, global.BottomCornerBadge);
    global.index = mod.exports;
  }
})(this, function (exports, _UpperCornerBadge, _BottomCornerBadge) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.BottomCornerBadge = exports.UpperCornerBadge = undefined;

  var _UpperCornerBadge2 = _interopRequireDefault(_UpperCornerBadge);

  var _BottomCornerBadge2 = _interopRequireDefault(_BottomCornerBadge);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.UpperCornerBadge = _UpperCornerBadge2.default;
  exports.BottomCornerBadge = _BottomCornerBadge2.default;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/elements/cornerBadge/index.js
// module id = 830
// module chunks = 1